import React from 'react'

function LabelNumber({ number }) {
  return (
    <span className="label__number">{number}</span>
  )
}

export default LabelNumber
